import {
  type BreakState,
  parseSettings,
  type TimerSettings,
} from '@dovefiniscono/core/focus/settings';

// The timer's settings and the break in progress stay in this browser, like the theme: the alarm
// belongs to the device that rings, and the break to the device you rest in front of.

const SETTINGS_KEY = 'dovefiniscono.focus.settings';
const BREAK_KEY = 'dovefiniscono.focus.break';

function read(key: string): unknown {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? null : JSON.parse(raw);
  } catch {
    return null;
  }
}

function write(key: string, value: unknown) {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Private browsing: nothing to remember.
  }
}

export const readSettings = () => parseSettings(read(SETTINGS_KEY));
export const saveSettings = (settings: TimerSettings) => write(SETTINGS_KEY, settings);

export function readBreak(): BreakState | null {
  const value = read(BREAK_KEY) as Partial<BreakState> | null;
  if (!value || typeof value.startedAt !== 'string' || typeof value.minutes !== 'number')
    return null;
  return {
    startedAt: value.startedAt,
    minutes: value.minutes,
    long: value.long === true,
    taskId: typeof value.taskId === 'string' ? value.taskId : null,
    label: typeof value.label === 'string' ? value.label : '',
  };
}

export const BREAK_CHANGED = 'dvf:break-changed';

export const saveBreak = (state: BreakState | null) => {
  write(BREAK_KEY, state);
  window.dispatchEvent(new Event(BREAK_CHANGED));
};
